/* global IntersectionObserver */
import '@splidejs/splide/css';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.logo-carousel-section');
    if (!sections.length) {return;}

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const section = entry.target;
                section.querySelectorAll('.lcs-item').forEach((item, index) => {
                    const logoSlider = item.querySelector('.lcs-logo-slider');
                    if (!logoSlider) {return;}

                    const direction = (index % 2 === 1) ? 'ltr' : 'rtl';
                    const splide = new Splide(logoSlider, {
                        type: 'loop',
                        drag: false,
                        arrows: false,
                        pagination: false,
                        autoWidth: true,
                        direction,
                        autoScroll: {
                            speed: 0.4,
                            pauseOnHover: false,
                        },
                    });

                    splide.mount({ AutoScroll });
                });
                obs.unobserve(section);
            }
        });
    }, { rootMargin: '150px' });

    sections.forEach(section => observer.observe(section));
});
